<template>
	<div class="page-content-wrapper">
		<div class="container-fluid">
			<div class="row">
				<div class="col-xl-12">
					<div class="card">
						<div class="card-body" style="margin-bottom: 30px;">
							  <h5>
								  <i class="fas fa-file-alt"></i> Reportes
							  </h5>
                <hr>
                <div class="contenedor-reporte">
                  <a href="#" style="text-decoration:none;" @click="descargarConsolidado()"><span class="textoReporte">Reporte Consolidado de Cursos</span></a>
                  <i v-if="!loaderReporte" class="fas fa-download" style="float: right;color:#23bbde;margin-top: 5px;cursor:pointer;" @click="descargarConsolidado()"></i>
                  <b-spinner small v-else style="float: right;color:#23bbde;margin-top: 5px;"> </b-spinner>
                  <br>
                    <div v-if="reporte != null">
                        <span>Campus: <strong>{{cCampus}}</strong></span><br>
                        <span>Cursos: <strong>{{cCursos}}</strong></span><br>
                        <span>Alumnos: <strong>{{cAlumnos}}</strong></span>
                        <br>
                        <a class="decoracion" href="#" @click="openReporte()">Descargar reporte</a>
                    </div>
                </div>
                <br>
                <div class="contenedor-reporte" v-if="this.showReporteK">
                  <a href="#" style="text-decoration:none;" @click="descargarGrupoK()"><span class="textoReporte">Reporte GrupoK</span></a>
                  <i v-if="!loaderReporte" class="fas fa-download" style="float: right;color:#23bbde;margin-top: 5px;cursor:pointer;" @click="descargarGrupoK()"></i>
                  <b-spinner small v-else style="float: right;color:#23bbde;margin-top: 5px;"> </b-spinner>
                    
                </div>
              </div>
						</div>
					</div>
				</div>
				<!-- end col -->
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      loaderReporte: false,
      reporte:null,
      cCampus:null,
      cCursos:null,
      cAlumnos:null,
      showReporteK:false
    }
  },
  computed: {
		...mapState('campus',['dataCampus']),
	},
  methods: {
    ...mapActions("menu", ["updateMenu"]),
    ...mapActions("menu", ["updateTitulo"]),
    ...mapActions("campus", ["addCampus"]),
    async descargarConsolidado(){
        //reiniciar las variables del reporte
        this.reiniciarVariables();
        //llamar api que retorne todos los alumnos de todos los cursos que tiene asignados
        this.loaderReporte = true;
        const { data } = await this.axios.get("api/getReporteConsolidadoCursoCampus").catch((e)=>this.loaderReporte = false);
        this.loaderReporte = false;
        if(data.status === 'success'){
          this.reporte = data.urlReporte;
          this.cCampus = data.totalCampus;
          this.cCursos = data.totalCursos;
          this.cAlumnos = data.totalAlumnos + 1;
        } else {
          alert(data.msg);
        }
        
    },
    async descargarGrupoK(){
        //reiniciar las variables del reporte
        //this.reiniciarVariables();
        //llamar api que retorne todos los alumnos de todos los cursos que tiene asignados
        //this.loaderReporte = true;
        const { data } = await this.axios.get("api/getReporteGrupoK").catch((e)=>this.loaderReporte = false);
        //console.log(data);
        //this.loaderReporte = false;
        if(data.status === 'success'){
          this.reporte = data.urlReporte;
          window.open(data.urlReporte, '_blank');
          //this.cCampus = data.totalCampus;
          //this.cCursos = data.totalCursos;
          //this.cAlumnos = data.totalAlumnos + 1;
        } else {
          alert(data.msg);
        }
        
    },
    openReporte(tipo){
      window.open(this.reporte, '_blank');
    },
    reiniciarVariables(){
      this.reporte = null;
      this.cCampus = null;
      this.cCursos = null;
      this.cAlumnos = null;
    },
  },
  created() {
    let titulo = "Panel Reportes";
    let menu = [
      { urlTolbar: "index", nameToolbar: "Inicio" },
      {
        titulo: "Reportes",
        urlTolbar: "reportes",
        nameToolbar: "Reportes",
      },
    ];
    this.updateMenu(menu);
    this.updateTitulo(titulo);
  },
  mounted(){
		let campus = JSON.parse(localStorage.getItem('listadoCampusDisponibles'));
    // Valor dado que quieres comparar
    var valorDado = 99979; // Cambia esto al valor que desees

    // Recorre el objeto y verifica si alguno de los idCampus coincide
    var encontrado = false;
    for (var i = 0; i < campus.length; i++) {
        if (campus[i].idCampus === valorDado) {
            encontrado = true;
            break; // Si se encuentra una coincidencia, puedes salir del bucle
        }
    }

    // Muestra una alerta si se encuentra una coincidencia
    if (encontrado) {
        this.showReporteK = true;
    }
	}
};
</script>
<style scoped>
.contenedor-reporte{
    padding: 10px;
    width: 50%;
    border: 2px solid #d2d2d2;
}
.textoReporte{
   font-size: 18px;
   color: #23bbde;
}
.decoracion{
  text-decoration: none;
  font-size: 15px;
   color: #23bbde;
}
</style>
